<div
  class="train-front-question text-simple-train-question text-typed-train-question mx-auto text-center"
  [class.has-front-image]="imageAsset()"
>
  {{ card().frontText || t()["train.noQuestionText"] }}
</div>

@if (imageAsset(); as image) {
  <div class="text-train-front-image-wrap mx-auto">
    <img class="text-train-front-image" [src]="image.url" [alt]="imageAlt" />
  </div>
}

@if (canSpeakQuestion()) {
  <button
    type="button"
    class="train-front-action train-question-audio-action btn btn-icon btn-outline-primary rounded-circle waves-effect"
    [class.train-audio-action-playing]="isQuestionAudioPlaying()"
    [attr.aria-label]="t()['train.listenQuestion']"
    [title]="t()['train.listenQuestion']"
    (click)="speak.emit()"
  >
    <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
      <use href="/assets/icons/sprite.svg#volume-2"></use>
    </svg>
  </button>
}
